export const currentTime = () => new Date().getTime();